import Vue from 'vue'
import { decode, parsePath, withoutBase, withoutTrailingSlash, normalizeURL } from 'ufo'

import { getMatchedComponentsInstances, getChildrenComponentInstancesUsingFetch, promisify, globalHandleError, urlJoin, sanitizeComponent } from './utils'
import NuxtError from '../client/layouts/error.vue'

import '../node_modules/normalize.css/normalize.css'

import '../client/assets/styles/main.scss'

import '../node_modules/arep-ui/dist/styles/index.css'

import _6f6c098b from '../client/layouts/default.vue'
import _2d230f00 from '../client/layouts/edit.vue'
import _15198306 from '../client/layouts/expansions/modals-expansion.vue'
import _7e1861e3 from '../client/layouts/expansions/segment-expansion/index.js'
import _58ba41c2 from '../client/layouts/expansions/segment-expansion/segment-section/index.js'
import _224164a5 from '../client/layouts/expansions/segment-expansion/segment-section/SegmentSection.vue'
import _ae7a77e2 from '../client/layouts/expansions/segment-expansion/SegmentWrapper.vue'
import _1c162e6e from '../client/layouts/expansions/sidebar-expansion.vue'
import _c49b8f80 from '../client/layouts/mono-no-auth.vue'
import _2d26dbd9 from '../client/layouts/mono.vue'
import _780998e4 from '../client/layouts/split.vue'

const layouts = { "_default": sanitizeComponent(_6f6c098b),"_edit": sanitizeComponent(_2d230f00),"_expansions/modals-expansion": sanitizeComponent(_15198306),"_expansions/segment-expansion/index": sanitizeComponent(_7e1861e3),"_expansions/segment-expansion/segment-section/index": sanitizeComponent(_58ba41c2),"_expansions/segment-expansion/segment-section/SegmentSection": sanitizeComponent(_224164a5),"_expansions/segment-expansion/SegmentWrapper": sanitizeComponent(_ae7a77e2),"_expansions/sidebar-expansion": sanitizeComponent(_1c162e6e),"_mono-no-auth": sanitizeComponent(_c49b8f80),"_mono": sanitizeComponent(_2d26dbd9),"_split": sanitizeComponent(_780998e4) }

export default {
  render (h, props) {
    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter (el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [templateEl])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [

      transitionEl
    ])
  },

  data: () => ({
    isOnline: true,

    layout: null,
    layoutName: '',

    nbFetching: 0
    }),

  beforeCreate () {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created () {
    // Add this.$nuxt in child instances
    this.$root.$options.$nuxt = this

    if (process.client) {
      // add to window so we can listen when ready
      window.$nuxt = this

      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
    // Add $nuxt.context
    this.context = this.$options.context
  },

  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline () {
      return !this.isOnline
    },

    isFetching () {
      return this.nbFetching > 0
    },

    isPreview () {
      return Boolean(this.$options.previewData)
    },
  },

  methods: {
    refreshOnlineStatus () {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    async refresh () {
      const pages = getMatchedComponentsInstances(this.$route)

      if (!pages.length) {
        return
      }

      const promises = pages.map((page) => {
        const p = []

        // Old fetch
        if (page.$options.fetch && page.$options.fetch.length) {
          p.push(promisify(page.$options.fetch, this.context))
        }
        if (page.$fetch) {
          p.push(page.$fetch())
        } else {
          // Get all component instance to call $fetch
          for (const component of getChildrenComponentInstancesUsingFetch(page.$vnode.componentInstance)) {
            p.push(component.$fetch())
          }
        }

        if (page.$options.asyncData) {
          p.push(
            promisify(page.$options.asyncData, this.context)
              .then((newData) => {
                for (const key in newData) {
                  Vue.set(page.$data, key, newData[key])
                }
              })
          )
        }

        return Promise.all(p)
      })
      try {
        await Promise.all(promises)
      } catch (error) {
        globalHandleError(error)
        this.error(error)
      }
    },
    errorChanged () {
      if (this.nuxt.err) {
        let errorLayout = (NuxtError.options || NuxtError).layout;

        if (typeof errorLayout === 'function') {
          errorLayout = errorLayout(this.context)
        }

        this.setLayout(errorLayout)
      }
    },

    setLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      this.layout = layouts['_' + layout]
      return this.layout
    },
    loadLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      return Promise.resolve(layouts['_' + layout])
    },
  },
}
